<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>help</md-icon>
          </div>
          <md-toolbar class="fm-card-header">
            <h4 class="md-title">Page Not Found</h4>
          </md-toolbar>
        </md-card-header>
        <md-card-content>
          <div class="md-layout">
            <div class="md-layout-item md-size-100">
              <h4>Oops!</h4>
              <p>The page you are looking for doesn't exist</p>
            </div>
          </div>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  computed: {},
  mounted() {},
  methods: {}
};
</script>
